module.exports = __webpack_public_path__ + "img/burger_boller_haevning.7cf2086b.jpg";